import { useEffect, useState } from "react";

import { fetchAppConfig, priceOf } from "../api/appConfig";
import { subscriptionPriceText } from "../utils/subscriptionPrice";

/**
 * What the server will charge for a payment type, read before the order so
 * the page never shows a different amount: { pricePaise, error }, both null
 * while it loads. Nothing is read while the type is null.
 */
export function usePrice(type) {
  const [state, setState] = useState({ pricePaise: null, error: null });
  useEffect(() => {
    if (!type) return undefined;
    let current = true;
    fetchAppConfig()
      .then((config) => {
        if (!current) return;
        const pricePaise = priceOf(config, type);
        setState(
          pricePaise
            ? { pricePaise, error: null }
            : {
                pricePaise: null,
                error: "The price couldn't be loaded. Try again in a moment.",
              },
        );
      })
      .catch(
        (err) =>
          current &&
          setState({
            pricePaise: null,
            error: err.message ?? "The price couldn't be loaded.",
          }),
      );
    return () => {
      current = false;
    };
  }, [type]);
  return state;
}

/**
 * The yearly subscription for institutions and organisations in words, from
 * the server's prices, or null until both are known.
 */
export function useSubscriptionPriceText() {
  const institution = usePrice("INSTITUTION_SUBSCRIPTION");
  const organisation = usePrice("ORGANISATION_SUBSCRIPTION");
  return subscriptionPriceText(institution.pricePaise, organisation.pricePaise);
}
